import * as Yup from "yup";

export const staffVoiceSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  phone: Yup.string()
    .max(25, "cannot be > 25 digits")
    .required("Please enter valid phone number"),
  email: Yup.string()
    .email("Please enter valid Username i.e email")
    .required("Username is required"),
  permissions: Yup.array().required("Select any admin privileges"),
});
